module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAuCAYAAAARD4idAAAACXBIWXMAACToAAAk6AGCYwUcAAAApUlEQVQ4je2UwQ3CMAxFfyPu7RS+wmhsAN0go8HRnoJOEPRDgSpNSW49kCdZspyf2E6sdCEEEDO7AjgD6PFiAuBFhHFEoZndAByR5y4ip05VueOSlXwZKXws0m0xuQoR6d0qtIGbuysRU/uCiPjq64k10uEVJGXQH+c1gCcuTVWHNEb7PGFN1/8nPLydNuEZ9pzwNrg/WQnNbKCl8faHF1PvMeEAns1joFUjouDgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-dropdown.png
// module id = FRhY
// module chunks = 0